export default {
  discounts:[],
  generalDiscount: null,
  maxDiscount:null
}